<ng-container *ngIf="{modal: (modalsService.modal$ | async)} as viewData">
    <ng-container *ngIf="viewData.modal.type === 'order_overview'">
        <app-order-overview-modal [orderId]="viewData.modal.data.orderId"
            [orderDetail]="viewData.modal.data.orderDetail"
            (orderModalComplete)="viewData.modal.data.orderModalComplete($event)">
        </app-order-overview-modal>
    </ng-container>
</ng-container>